import { render, staticRenderFns } from "./VanishingTimerPublic.vue?vue&type=template&id=2228b878&"
import script from "./VanishingTimerPublic.vue?vue&type=script&lang=js&"
export * from "./VanishingTimerPublic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports